import { reactive } from 'vue';
import { formatUnknownError } from '@/utils/formatUnknownError';
import {
  appendErrorItem,
  type AppErrorLogItem,
  APP_ERROR_LOG_MAX_ITEMS,
  normalizeErrorMessage,
} from '@/utils/appErrorLog';

let idSeq = 0;

function nextId(): string {
  return `${Date.now()}-${++idSeq}`;
}

export const appNotifyState = reactive({
  snackbarVisible: false,
  logDialogOpen: false,
  items: [] as AppErrorLogItem[],
});

export function notifyError(message: string): void {
  const text = normalizeErrorMessage(message);
  const now = Date.now();
  const entry: AppErrorLogItem = { id: nextId(), at: now, message: text };

  appNotifyState.items = appendErrorItem(
    appNotifyState.items,
    entry,
    APP_ERROR_LOG_MAX_ITEMS
  );
  appNotifyState.snackbarVisible = true;
}

export function notifyErrorFromUnknown(e: unknown): void {
  notifyError(formatUnknownError(e));
}

export function openErrorLog(): void {
  appNotifyState.logDialogOpen = true;
}

export function closeErrorLog(): void {
  appNotifyState.logDialogOpen = false;
}

export function clearErrorLog(): void {
  appNotifyState.items = [];
}

export function dismissErrorSnackbar(): void {
  appNotifyState.snackbarVisible = false;
}
